// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1WCLO","overflowing":"ReadFullNote_overflowing__1K1r2"};